import React from 'react'

const Icon = ({ size }) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox={`0 0 ${size} ${size}`}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 3H20C21.1046 3 22 3.89543 22 5V17C22 18.1046 21.1046 19 20 19H17C17.5523 19 18 19.4477 18 20C18 20.5523 17.5523 21 17 21H7C6.44771 21 6 20.5523 6 20C6 19.4477 6.44772 19 7 19H4C2.89543 19 2 18.1046 2 17V5C2 3.89543 2.89543 3 4 3ZM4 5V17H20V5H4Z' fill='#5E6D7A'
    />
  </svg>
)

export default Icon
